import script from "./OkrIconAndId.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrIconAndId.vue?vue&type=script&setup=true&lang=js"

import "./OkrIconAndId.vue?vue&type=style&index=0&id=4d33399a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d33399a"]])

export default __exports__